
import { ProgramCategory } from '@/services/db/types';
import { PROGRAM_LISTS } from '@/services/db/constants';

export const useProgramLists = () => {
  const programCategories: ProgramCategory[] = [
    'DIT Programs',
    'Special Packages', 
    'Web Development', 
    'Networking', 
    'Programming Languages',
    'Language',
    'English File',
    'CEL',
    'DEL'
  ];
  
  const programsByCategory = PROGRAM_LISTS;

  return {
    programCategories,
    programsByCategory
  };
};
